import type { Plan } from '../plan';

export const plans: Plan[] = [
  {
    value: 'A',
    text: 'Mini',
    sizes: [
      { value: 1, regular: 415, specialTerms: 290 },
      { value: 4, regular: 830, specialTerms: 580 },
      { value: 9, regular: 1620, specialTerms: 1130 },
      { value: 16, regular: 2620, specialTerms: 1830 },
    ],
  },
  {
    value: 'B',
    text: 'Basis',
    sizes: [
      { value: 1, regular: 470, specialTerms: 325 },
      { value: 4, regular: 935, specialTerms: 650 },
      { value: 9, regular: 1820, specialTerms: 1270 },
      { value: 16, regular: 2940, specialTerms: 2055 },
    ],
  },
  {
    value: 'C',
    text: 'Ekstra',
    sizes: [
      { value: 1, regular: 1180, specialTerms: 1035 },
      { value: 4, regular: 2365, specialTerms: 2080 },
      { value: 9, regular: 4610, specialTerms: 4060 },
      { value: 16, regular: 7445, specialTerms: 6560 },
    ],
  },
];
